import React from 'react'

import {Modal, Button} from 'semantic-ui-react'

import { Header  } from 'semantic-ui-react'


const ConfirmModal = (props:{
    icon? : object
    header? : string
    textContent : string,
    isOpen : boolean,
    onAccept : () => void,
    toggleOpen : (open : boolean) => void;
}) => {
    const acceptOnClick = () => {
        props.toggleOpen(false);
        props.onAccept();
    }

    return(
        <Modal
            onClose={() => props.toggleOpen(false)}
            open={props.isOpen}
            size='mini'
            basic
        >
            <Header icon>
                <>
                    {props.icon && props.icon}
                    {props.header && props.header}
                </>
            </Header>
            <Modal.Content>
                {props.textContent}
            </Modal.Content>
            <Modal.Actions>
            <Button 
                basic color='red' inverted
                onClick={() => props.toggleOpen(false)}
            >
                 Cancel
            </Button>
            <Button
                content="Confirm"
                onClick={() => acceptOnClick()}
                color='green' inverted
            />
            </Modal.Actions>


        </Modal>
    )    
}

export default ConfirmModal;